import React from "react";
import "./HeroV2.css";
import { Link } from "react-router-dom";

export default function HeroV2() {
  return (
    <section className="heroV2" id="top">
      <div className="v2-container heroV2-inner">
        <div className="heroV2-left">
          <div className="heroV2-eyebrow">PERFORMANCE COACHING PLATFORM</div>

          <h1 className="heroV2-title">
            Train your brain.<br />
            Sharpen your reflexes.<br />
            Perform under pressure.
          </h1>

          <p className="heroV2-sub">
            Evidence-inspired training for athletes and high performers to improve visual clarity,
            reaction speed, decision-making and focus — on and off the field.
          </p>

          <div className="heroV2-ctaRow">
            <Link className="heroV2-primary" to="/webinar">
                 Join Free Webinar
            </Link>
            <a className="heroV2-secondary" href="https://calendly.com/vevek-neo/forgeyourpeak-performance-discovery-call">
              Book a Discovery Call
            </a>
          </div>

          <div className="heroV2-stats">
            <div className="heroV2-stat">
              <div className="heroV2-statNum">20+</div>
              <div className="heroV2-statLabel">Neuro-Visual Protocols</div>
            </div>
            <div className="heroV2-stat">
              <div className="heroV2-statNum">95%</div>
              <div className="heroV2-statLabel">Client Satisfaction</div>
            </div>
            <div className="heroV2-stat">
              <div className="heroV2-statNum">1000+</div>
              <div className="heroV2-statLabel">Assessments Conducted</div>
            </div>
          </div>
        </div>

        <div className="heroV2-right">
          <div className="heroV2-photoCard">
            {/* Replace this placeholder with your actual hero image later */}
            <img
            src="/hero/vevek-hero.jpeg"
            alt="ForgeYourPeak Coach"
            className="heroV2-photo"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
